module.exports = __webpack_public_path__ + "img/table.686129a3.svg";